import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { styled } from "@mui/material/styles";

export const Icon = styled(InfoOutlinedIcon)`
  position: absolute;
  left: -4px;
  top: 50%;
  transform: translate(-50%, -50%);
`;
